/* eslint-disable import/prefer-default-export */

import { memo } from 'react';
import { withSentryRouting, ErrorBoundary } from '@sentry/react';
import { Route } from 'react-router-dom';

import GlobalError from 'componentsV2/GlobalError';
import { PropsOf } from './types.utils';

const SentryRoute = withSentryRouting(Route);

export const SentryErrorBoundRoute = memo((props: PropsOf<typeof SentryRoute>) => (
  <ErrorBoundary
    // @ts-expect-error TS(2769): No overload matches this call.
    fallback={({ resetError }) => <GlobalError resetError={resetError} />}
    beforeCapture={(scope) => {
      // Tagging each ErrorBoundary with their respective path
      // @ts-expect-error TS(2339): Property 'path' does not exist on type 'PropsWithC... Remove this comment to see the full error message
      scope.setTag('path', props.path);
    }}
  >
    <SentryRoute {...props} />
  </ErrorBoundary>
));
